import { render, staticRenderFns } from "./Worklist.vue?vue&type=template&id=5c04ebc6&scoped=true"
import script from "./Worklist.vue?vue&type=script&lang=js"
export * from "./Worklist.vue?vue&type=script&lang=js"
import style0 from "./Worklist.vue?vue&type=style&index=0&id=5c04ebc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c04ebc6",
  null
  
)

export default component.exports